import { useState } from "react";

export type Density = "compact" | "default" | "comfortable";

const KEY = "atlas.inventory.density";

export function useDensity(): [Density, (d: Density) => void] {
  const [density, setDensityState] = useState<Density>(() => {
    if (typeof window === "undefined") return "default";
    const v = localStorage.getItem(KEY);
    return v === "compact" || v === "default" || v === "comfortable" ? v : "default";
  });

  const setDensity = (d: Density): void => {
    setDensityState(d);
    try {
      localStorage.setItem(KEY, d);
    } catch {
      /* quota / privacy mode — ignore */
    }
  };

  return [density, setDensity];
}

export const ROW_HEIGHT: Record<Density, string> = {
  compact: "h-10",
  default: "h-[52px]",
  comfortable: "h-[60px]",
};
